import React, { useState } from "react";
import styled from "styled-components";
import colors from "../../../theme/color/ColorTheme";
import fontSize from "../../../theme/fonts/FontTheme";

const TabButton = styled.button`
  width: 100px;
  height: 40px;
  border: none;
  padding: ${({ active }) => (active ? "5px" : "0")};
  cursor: pointer;
  font-size: ${fontSize.xs};
  letter-spacing: 0.12rem;
  color: ${({ active }) => (active ? "white" : colors.black)};
  background-color: ${({ active }) => (active ? colors.black : "#eaeaea")};
  box-shadow: ${({ active }) =>
    active ? `inset 0 0 0 4px ${colors.black}` : `none`};
  background-clip: content-box;

  &:hover {
    background-color: ${({ active }) => (active ? "#242424" : "#e1dede")};
    box-shadow: ${({ active }) =>
      active ? `inset 0 0 0 4px #242424` : "none"};
  }
`;

const TabsWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
`;

function Tabs({ tabs, active, onChange }) {
  return (
    <TabsWrapper>
      {tabs.map((tab, index) => (
        <TabButton
          key={tab}
          active={active === index}
          onClick={() => onChange(index)}
        >
          {tab}
        </TabButton>
      ))}
    </TabsWrapper>
  );
}
 
export default Tabs;
